import type { SxProps, Theme } from '@mui/material/styles';
import { SIDE_PADDING } from '../AiChat/utils/consts';

export const rootSx: SxProps<Theme> = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 1,
  overflow: 'hidden',
  borderRadius: 1,
  backgroundColor: 'background.paper',
  px: SIDE_PADDING,
  py: 1.25,
};

export const inputSx: SxProps<Theme> = {
  border: 'none',
  '&:focus': { outline: 'none' },
  py: 0.75,
  fontSize: 15,
  fontWeight: theme => theme.typography.fontWeightRegular,
  lineHeight: theme => theme.typography.body1.lineHeight,
  letterSpacing: theme => theme.typography.h1.letterSpacing,
  '&.MuiInput-root > textarea': {
    borderRadius: 1,
  },
};

export const sendButtonSx: SxProps<Theme> = theme => ({
  backgroundColor: theme.palette.primary.main,
  '&:hover': { backgroundColor: theme.palette.primary.dark },
  '&.MuiIconButton-root': {
    borderRadius: 1,
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.action.disabledBackground,
  },
});
